import { useState, type ReactNode } from 'react';
import { Button } from '../../../components/Button';
import { Field } from '../../../components/Field';
import { Textarea } from '../../../components/Input';
import styles from '../CvBank.module.css';

const MIN_REASON = 3;

/**
 * "Remove from CV Bank", anchored to its button (CLAUDE.md §5): ADR 0046 records why a CV left.
 * Removing is undoable for 10 s, so this asks for the reason, never for confirmation.
 */
export function RemovePanel({ who, onRemove, onCancel }: { readonly who: string; readonly onRemove: (reason: string) => void; readonly onCancel: () => void }): ReactNode {
  const [reason, setReason] = useState('');
  const [problem, setProblem] = useState<string | null>(null);

  const submit = (): void => {
    if (reason.trim().length < MIN_REASON) {
      setProblem('Say why, in a few words.');
      return;
    }
    onRemove(reason.trim());
  };

  return (
    <div className={styles.panel}>
      <p className={styles.panelTitle}>Remove {who} from the CV Bank</p>
      <Field label="Why?" isRequired {...(problem ? { error: problem } : {})}>
        {(ids) => (
          <Textarea
            id={ids.inputId}
            aria-describedby={ids.describedBy}
            isInvalid={ids.isInvalid}
            value={reason}
            rows={2}
            maxLength={300}
            placeholder="For example: no longer looking"
            onChange={(event) => {
              setReason(event.target.value);
              setProblem(null);
            }}
          />
        )}
      </Field>
      <div className={styles.panelActions}>
        <Button variant="ghost" onClick={onCancel}>
          Cancel
        </Button>
        <Button variant="danger" onClick={submit}>
          Remove
        </Button>
      </div>
    </div>
  );
}
